import React from 'react';
import { ArrowDown, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <header className="relative min-h-[90vh] flex flex-col justify-center bg-white text-black border-b-8 border-black" data-id="element-56">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-57">
        <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=2000&auto=format&fit=crop" alt="Hombre latino pensando" className="w-full h-full object-cover grayscale opacity-20" data-id="element-58" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/50 to-white" data-id="element-59"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-20 pb-12 text-center md:text-left" data-id="element-60">
        <div className="inline-block bg-black text-white px-3 py-1 text-sm font-bold tracking-widest mb-6 uppercase" data-id="element-61">
          PARA HOMBRES OCUPADOS
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.9] mb-8 tracking-tighter uppercase" data-id="element-62">
          Si sigues <span className="text-red-600 bg-black px-2" data-id="element-63">pobre</span> y
          estancado, no es falta de inteligencia
        </h1>

        <p className="text-xl md:text-3xl font-medium leading-tight mb-10 max-w-3xl border-l-4 border-red-600 pl-6 text-gray-900" data-id="element-64">
          Es que tu día está diseñado para no producir dinero.
        </p>

        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mt-12" data-id="element-65">
          <div className="flex flex-col gap-2" data-id="element-66">
            <span className="text-sm font-bold uppercase tracking-wider text-gray-500" data-id="element-67">
              Producto Digital
            </span>
            <span className="text-2xl font-bold font-sans" data-id="element-68">
              Protocolo Antipobreza™ en PDF
            </span>
          </div>

          <a href="https://glowliftessencemx.com/checkouts/cn/hWN7p0uqD5uNg58daDP06dxi/es-us?_r=AQABAEf7uOD-4Qp3sVkjC_dqmN7SeRIA3Kk7eavabZSDjF4&preview_theme_id=184489181460" className="group relative inline-flex items-center justify-center bg-red-600 text-white text-xl font-bold uppercase tracking-wide px-8 py-4 hover:bg-red-700 transition-all shadow-brutal hover:translate-y-1 hover:shadow-none" data-id="element-69">
            Descargar Protocolo – $9.99
            <ArrowDown className="ml-2 h-6 w-6 group-hover:animate-bounce" data-id="element-70" />
          </a>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-4 text-sm font-medium text-gray-600" data-id="element-71">
          <span className="flex items-center" data-id="element-72">
            <CheckCircle2 className="w-4 h-4 mr-1 text-black" data-id="element-73" /> Acceso
            inmediato en PDF
          </span>
          <span className="hidden md:inline" data-id="element-74">•</span>
          <span className="flex items-center" data-id="element-75">
            <CheckCircle2 className="w-4 h-4 mr-1 text-black" data-id="element-76" /> Pago único y
            seguro
          </span>
        </div>
      </div>
    </header>;
}